import { renderHeaderContent } from '@/content/chrome';

// Public content remains static; only the header reflects the shared session.
export function createPublicHeaderUpdater(header, readSession, docsUrl) {
  let latestCheck = 0;
  return async () => {
    const check = ++latestCheck;
    let isLoggedIn = false;
    try {
      const session = await readSession();
      isLoggedIn = !!session.tokens?.idToken;
    } catch {
      // Expired or unavailable sessions retain the public navigation.
    }
    if (check !== latestCheck) return;
    header.innerHTML = renderHeaderContent({ docsUrl, isLoggedIn });
  };
}
